import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt", "src", "data-src", "fillFrame", "fillParent", "onError", "onLoad", "transparentBackground", "children"];
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { alpha } from 'utils/ui/colors';
import { fadeIn } from 'styles/animations';
import { fillParent } from 'styles/mixins';
import config from 'utils/config';
var Wrapper = styled.div.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "ImageWithLoader__Wrapper",
  componentId: "sc-qxodop-0"
})(["display:block;", " border-radius:inherit;"], function (p) {
  return p.fillParent && fillParent;
});
var LoadingIndicator = styled.div.withConfig({
  displayName: "ImageWithLoader__LoadingIndicator",
  componentId: "sc-qxodop-1"
})(["", " background-color:", ";animation:", " 750ms ease-out alternate infinite;"], fillParent, alpha('white', 0.15), fadeIn);
var StyledImage = styled.img.withConfig({
  displayName: "ImageWithLoader__StyledImage",
  componentId: "sc-qxodop-2"
})(["position:relative;display:block;width:100%;height:100%;object-fit:", ";", " transition:opacity 250ms linear;animation:", " 0.25s ease-in;"], function (p) {
  return p.fillFrame ? 'cover' : 'contain';
}, function (p) {
  return !p.transparentBackground && css(["background-color:white;"]);
}, fadeIn);
var Picture = styled.picture.withConfig({
  displayName: "ImageWithLoader__Picture",
  componentId: "sc-qxodop-3"
})(["border-radius:inherit;"]);
function ImageWithLoader(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    src = _ref.src,
    dataSrc = _ref['data-src'],
    _ref$fillFrame = _ref.fillFrame,
    fillFrame = _ref$fillFrame === void 0 ? true : _ref$fillFrame,
    _ref$fillParent = _ref.fillParent,
    fillParent = _ref$fillParent === void 0 ? true : _ref$fillParent,
    onError = _ref.onError,
    onLoad = _ref.onLoad,
    _ref$transparentBackg = _ref.transparentBackground,
    transparentBackground = _ref$transparentBackg === void 0 ? false : _ref$transparentBackg,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasErrored = _useState4[0],
    setErrored = _useState4[1];
  var handleErrored = function handleErrored(e) {
    setErrored(true);
    onError === null || onError === void 0 ? void 0 : onError(e);
  };
  var handleLoaded = function handleLoaded(e) {
    setLoading(false);
    onLoad === null || onLoad === void 0 ? void 0 : onLoad(e);
  };
  var source = src || dataSrc;
  var formats = [];

  // Only attach formats when the source is a link to our picture API
  if (source !== null && source !== void 0 && source.startsWith('/api/picture/')) {
    if (!/\bf_(original|png|jpeg|webp|svg|avif)\b/.test(source)) {
      formats.push('avif', 'webp');
      if (src) {
        src += ',f_original';
      }
      if (dataSrc) {
        dataSrc += ',f_original';
      }
    }

    // Auto position images around a focal point
    if (config.imageAutoCentering) {
      if (src) {
        src += ',g_auto';
      }
      if (dataSrc) {
        dataSrc += ',g_auto';
      }
    }
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    fillParent: fillParent,
    fillFrame: fillFrame,
    usePlaceHolderHeight: !fillParent && (isLoading || hasErrored)
  }, isLoading && !hasErrored && /*#__PURE__*/React.createElement(LoadingIndicator, null), !hasErrored && /*#__PURE__*/React.createElement(Picture, null, formats.map(function (format) {
    return /*#__PURE__*/React.createElement("source", {
      key: format,
      srcSet: "".concat(source, ",f_").concat(format).concat(config.imageAutoCentering ? ',g_auto' : ''),
      type: "image/".concat(format)
    });
  }), /*#__PURE__*/React.createElement(StyledImage, _extends({}, otherProps, {
    src: src,
    "data-src": dataSrc,
    alt: alt,
    fillFrame: fillFrame,
    transparentBackground: transparentBackground,
    style: {
      opacity: isLoading ? '0' : '1'
    },
    onLoad: handleLoaded,
    onError: handleErrored
  }))), children);
}
export default ImageWithLoader;